<template>
	<div class="visitDetail">
		<div class="module-item-style mgt10">
			<div class="filter-wrapper">
				<div class="filter-wrapper-item">
					<el-date-picker
							size="small"
							v-model="selectTime"
							type="daterange"
							@change="timeSelect"
							range-separator="~"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format="yyyy-MM-dd"
							value-format="timestamp"
							:picker-options="pickerOptions"
					>
					</el-date-picker>
				</div>
				<div class="filter-wrapper-item">
					<el-input
							size="small"
							placeholder="关键词模糊搜索" v-model="searchInfo.likeWord" class="input-with-select">
						<el-button @click="searchList" slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
			</div>
		</div>
		<div class="module-item-style mgt10">
			<div class="table-border">
				<el-table
					size="small"
					v-loading="isLoading"
					stripe
					:data="tableData"
					:header-cell-style="{ background:'#f2f2f2' }">
					<el-table-column
							label="访问时间">
						<template slot-scope="scope">
							{{ scope.row.createTime }}
						</template>
					</el-table-column>
					<el-table-column
							label="地域">
						<template slot-scope="scope">
							<span v-if="scope.row.trackAddrCountry">{{ scope.row.trackAddrCountry }}、{{ scope.row.trackAddrProvince }}、{{ scope.row.trackAddrCity }}</span>
							<span v-else>—</span>

						</template>
					</el-table-column>
					<el-table-column
							label="关键词">
						<template slot-scope="scope">
							<span v-if="scope.row.trackKeyword">{{scope.row.trackKeyword}}</span>
							<span v-else>—</span>
						</template>
					</el-table-column>
					<el-table-column
							label="入口页面">
						<template slot-scope="scope">
							<a class="link" :href="scope.row.trackUrl" target="_blank">{{ scope.row.trackTitle }}</a>
						</template>
					</el-table-column>
					<!--<el-table-column
							label="访问IP">
						<template slot-scope="scope">
							{{ scope.row.createTime }}
						</template>
					</el-table-column>-->
					<!--<el-table-column
							label="操作">
						<template slot-scope="scope">

						</template>
					</el-table-column>-->
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="searchInfo.pageNum"
					:page-size="10"
					layout="total, prev, pager, next, jumper"
					:total="pageTotal">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
  import { visitDetailList } from '@/api/modules/report/website'
  export default {
    name: 'index',
    data() {
      return {
        isLoading: false,
        tableData: [],
        pageTotal: 0,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
					}
				},
        searchInfo: {
          likeWord: '',
          pageNum: 1,
          startTime: '',
          endTime: ''
        },
        selectTime: ''
      }
    },
    methods: {
      /**
       * 时间选择
       */
      timeSelect() {
        if (this.selectTime) {
          this.searchInfo.startTime = this.selectTime[0] / 1000
					let endTime = this.selectTime[1] / 1000
					this.searchInfo.endTime = endTime + 24 * 60 * 60 - 1
        } else {
          this.searchInfo.startTime = ''
          this.searchInfo.endTime = ''
        }

        this.$nextTick(() => {
          this.searchList()
        })
      },
      searchList() {
        this.visitDetailListFn()
      },
      visitDetailListFn() {
        const param = this.searchInfo
        this.$http.visitDetailList(param).then(res => {
          if (res.status == 1) {
            const tableData = res.data.data
            tableData.forEach(item => {
              item.createTime = this.disposeDate(item.createTime)
            })
            this.tableData = tableData
            this.pageTotal = res.data.total
          }

        })
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.searchInfo.pageNum = val
        this.searchList()
        // console.log(`当前页: ${val}`);
      },
      // 处理时间
      disposeDate(dateTime) {
        const getTime = new Date(dateTime * 1000)    //从后台获取过来的时间戳
        const Y = getTime.getFullYear()
        const M = getTime.getMonth() < 9 ? '0' + (getTime.getMonth() + 1): getTime.getMonth() + 1
        const D = getTime.getDay() < 10 ? '0' + getTime.getDay(): getTime.getDay()
        return `${Y}-${M}-${D}`
      },
    },
    created() {
      this.searchList()
    }
  }
</script>

<style scoped lang="scss">
	.visitDetail{
		.link{
			text-decoration: underline;
			&:hover{
				color: #3a8ee6;
			}
		}
	}
</style>
